// extracted by mini-css-extract-plugin
module.exports = {"table":"LabeledListPreview_table__1aTHf","bullet":"LabeledListPreview_bullet__1NG-N","label":"LabeledListPreview_label__jUGv1"};